import { Box, CircularProgress } from "@mui/joy";

export function AlbumImageUploadOverlay() {
    return (
        <Box
            sx={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "rgba(0,0,0,0.45)",
                zIndex: 1,
                pointerEvents: "none",
            }}
        >
            <CircularProgress size="sm" sx={{ color: "#fff" }} />
        </Box>
    );
}
